export function delay(t): Promise<void> {
  // tslint:disable-next-line:only-arrow-functions
  return new Promise(function(resolve) {
    setTimeout(resolve.bind(null), t);
  });
}
